import { RegularPresentAcceptActivityPayCheckPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularPresentAcceptActivityPayCheck";
import React from "react";

const RegularPresentAcceptanceActivityPayCheck = () => {
  return <RegularPresentAcceptActivityPayCheckPage />;
};

export default RegularPresentAcceptanceActivityPayCheck;
